import { __spreadArray } from '../../_virtual/_tslib.js';
import Vue from 'vue';
import __vue_component__ from './SbAutoCompleteInput.vue.js';

var script = Vue.extend({
    name: 'SbSearchableSelect',
    props: {
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: [Object, String],
            required: false,
            default: null,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        minSearchCharacters: {
            type: Number,
            required: false,
            default: 0,
        },
        maxAutocompleteResults: {
            type: Number,
            required: false,
            default: null,
        },
        searchFunction: {
            type: Function,
            required: false,
            default: undefined,
        },
        findInSuggestions: {
            type: Boolean,
            required: false,
            default: false,
        },
        closeSuggestionsOnSubmit: {
            type: Boolean,
            required: false,
            default: false,
        },
        isIconRight: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            query: '',
            allSuggestions: [],
            areSuggestionsShown: false,
        };
    },
    created: function () {
        this.mapSearchedSuggestions(this.query);
    },
    computed: {
        suggestions: function () {
            if (this.maxAutocompleteResults) {
                return this.allSuggestions.slice(0, this.maxAutocompleteResults);
            }
            return this.allSuggestions;
        },
    },
    watch: {
        query: function (newValue) {
            this.mapSearchedSuggestions(newValue);
        },
        options: function () {
            this.mapSearchedSuggestions(this.query);
        },
    },
    methods: {
        handleSubmit: function () {
            var _this = this;
            if (!this.closeSuggestionsOnSubmit) {
                this.areSuggestionsShown = true;
            }
            if (this.query.trim().length >= this.minSearchCharacters) {
                var returnValue = this.findInSuggestions ? this.options.find(function (suggestion) { return typeof suggestion === 'string'
                    ? suggestion === _this.query
                    : suggestion.label === _this.query; }) : null;
                if (returnValue) {
                    this.$emit('input', typeof returnValue === 'string' ? returnValue : returnValue.value);
                }
                else {
                    this.$emit('input', this.query);
                }
            }
        },
        mapSuggestions: function (suggestions) {
            return suggestions.map(function (suggestion) { return typeof suggestion === 'string' ? suggestion : suggestion.label; });
        },
        showSuggestions: function () {
            this.areSuggestionsShown = true;
        },
        onSuggestionsStateChange: function (value) {
            if (!value) {
                this.areSuggestionsShown = false;
            }
        },
        search: function (query) {
            if (this.searchFunction) {
                return this.searchFunction(query);
            }
            var getLabel = function (suggestion) { return typeof suggestion === 'string'
                ? suggestion
                : suggestion.label; };
            if (query) {
                var prefixOptions = this.options.filter(function (option) { return getLabel(option)
                    .toLowerCase()
                    .startsWith(query.toLowerCase()); });
                var infixOptions = this.options.filter(function (option) { return !getLabel(option)
                    .toLowerCase()
                    .startsWith(query.toLowerCase()); }).filter(function (option) { return getLabel(option)
                    .toLowerCase()
                    .includes(query.toLowerCase()); });
                return __spreadArray(__spreadArray([], prefixOptions, true), infixOptions, true);
            }
            return this.options;
        },
        mapSearchedSuggestions: function (query) {
            if (query.trim().length >= this.minSearchCharacters) {
                this.allSuggestions = this.mapSuggestions(this.search(query));
            }
            else {
                this.allSuggestions = this.mapSuggestions(this.options);
            }
        },
    },
    components: {
        SbAutoCompleteInput: __vue_component__,
    },
});

export default script;
